import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findEngineeringDynamic = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-dynamic?` + params,
        method: 'GET'
    })
}
export const findEngineeringDynamicDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-dynamic/downloadExcel?` + params,
        method: 'GET'
    })
}
export const findEngineeringDynamicId = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-dynamic/${id}`,
        method: 'GET'
    })
}
export const findEngineeringProjectAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-project/all`,
        method: 'GET'
    })
}
/**
 * 控件类型列表
 */
export const findDataSourceFields = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/dataSource/fields`,
        method: 'GET'
    })
}
/**
 * 数据源
 */
export const findDataSourceAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/dataSource`,
        method: 'GET'
    })
}

export const addDynamic = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-dynamic`,
        method: 'POST',
        data: params
    })
}
export const findEngineeringDynamicDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-dynamic/${id}`,
        method: 'GET'
    })
}
export const editEngineeringDynamic = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-dynamic`,
        method: 'PUT',
        data: params
    })
}










export const findAllSuperiorDepartment = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
        method: 'GET'
    })
}
export const findProvince = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province`,
        method: 'GET'
    })
}

export const findAreas = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
        method: 'GET'
    })
}

export const delProject = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-project/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}








export const findTagslList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label?` + params,
        method: 'GET'
    })
}

export const findLabelList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label/select?` + params,
        method: 'GET'
    })
}

export const addTags = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label`,
        method: 'POST',
        data: params
    })
}
export const editTags = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label`,
        method: 'PUT',
        data: params
    })
}

export const delTags = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/label/${ids}`,
        method: 'DELETE',
    })
}